
const HOST = process.env.NEXT_PUBLIC_API_BASE_URL;
const CURRENT_ENV = process.env.NEXT_PUBLIC_ENVIRONMENT;

export const API = {
                      subscribe_notification: '/api/v1/subscribe_notification',
                      referral_users: '/api/v1/referral_users',
                      user_sidebar_data: '/api/v1/user_sidebar_data',
                      other_source_users: '/api/v1/candidate_other_sources',
                      admins: {
                                            LOGIN_SUBMIT_URL: '/api/v1/sign_in',
                                            MAGIC_LINK_LOGIN_URL: '/api/v1/magic_sign_in',
                                            MAGIC_LINK_REQUEST_URL: '/api/v1/magic_sign_in_link',
                                            OTP_VERIFY_URL: '/api/v1/confirm_otp',
                                            RESEND_OTP_URL: '/api/v1/resend_otp',
                                            RESET_PASSWORD_URL: '/api/v1/reset_password_token',
                                            SET_PASSWORD_URL: '/api/v1/users/password',
                                            LOGOUT_URL: '/api/v1/users/sign_out',
                                            dashboard:{
                                                          activity:{
                                                                      index:'/api/v1/admins/activities/index',
                                                                      get_data:'/api/v1/admins/activities/get_stats_data'
                                                                  },
                                                          clients:{
                                                                     company      : {
                                                                                       CREATE: '/api/v1/clients',
                                                                                       EDIT: `/api/v1/clients/$client_id`,
                                                                                       UPDATE: '/api/v1/clients/$client_id',
                                                                                       GET_CLIENTS_LIST: '/api/v1/clients',
                                                                                       DELETE_CLIENT: '/api/v1/clients/$client_id',
                                                                                       ACTIVE_AND_INACTIVE: '/api/v1/clients/$client_id/active_or_inactive'
                                                                                    },
                                                                     users        : {
                                                                                          GET_NEW_CLIENT_ROLE_URL: `/api/v1/roles`,
                                                                                          CREATE_NEW_CLIENTS_URL: '/api/v1/clients/$client_id/add_users',
                                                                                    },
                                                                     integration  : {
                                                                                          CLIENT_INTEGRATIONS_URL: `/api/v1/clients/$client_id/integrations`,
                                                                                          ADD_INTEGRATIONS_URL: '/api/v1/clients/$client_id/add_integrations',
                                                                                    },
                                                                     jobs         : {
                                                                                          GET_JOBS_LIST:'/api/v1/jobs',
                                                                                          UPDATE_CAREER_PAGE: `/api/v1/career_page/update`,
                                                                                          UPDATE_ADVERT_PAGE: `/api/v1/career_page/update_advert`,
                                                                                          FAILED_JOB_BOARDS: '/api/v1/jobs/$job_id/failed_job_boards',
                                                                                          RETRY_JOB_BOARD: ' /api/v1/jobs/$job_id/retry_posting',
                                                                                          DISMISS_JOB_BOARD: '/api/v1/jobs/$job_id/job_posts'
                                                                                    },
                                                                     offers        : {
                                                                        APPROVALS_LIST: '/api/v1/offer_approvers',
                                                                        OFFER_DETAILS: '/api/v1/offer_approvers/$id/offer_details',
                                                                        APPROVE_OFFER: '/api/v1/offer_approvers/$id/approve_offer',
                                                                        REJECT_OFFER: '/api/v1/offer_approvers/$id/reject_offer',
                                                                        SEND_OFFER: '/api/v1/offers/$offer_id/send_offer_to_candidate',

                                                                        APPROVAL_SUMMARY: '/api/v1/get_offer_summary',
                                                                        APPROVE_OFFER_APPROVAL: '/api/v1/approve_offer_approval',
                                                                        REJECT_OFFER_APPROVAL: '/api/v1/reject_offer_approval'
                                                                        }
                                                                  },
                                                            users:{
                                                                     ADMIN_MEMBERS: `${HOST}/api/v1/admins`,
                                                                     ADMINS: '/api/v1/admins',
                                                                     UPDATE_USER_STATUS:'/api/v1/admins/$admin_id/update_status',
                                                                     RESEND_INVITE:' /api/v1/admins/$admin_id/resend_invite',
                                                                     ADMIN: '/api/v1/admins/$admin_id'
                                                                  }
                                                      }
                              },
                      client: {
                                 candidates   : {
                                                   GET_CANDIDATE_LIST: '/api/v1/client_candidates',
                                                   GET_TALENT_POOL_LIST: '/api/v1/talent_pools',
                                                   GET_CANDIDATE_TOKEN: '/api/v1/client_candidates/$client_candidate_id/candidate_token?job_application_id=$job_application_id&job_id=$job_id',
                                                   DOWNLOAD_CANDIDATE_RESUMES:'/api/v1/client_candidates/download_resumes',
                                                   ACTIVATE_JOB_LIST: '/api/v1/client_candidates/active_jobs',
                                                   DELETE_CANDIDATES: '/api/v1/client_candidates/delete_candidates',
                                                   ADD_TO_JOBS: '/api/v1/client_candidates/add_to_jobs',
                                                   ADD_MEDIA_DETAILS: '/api/v1/social_media_details',
                                                   UPDATE_MEDIA_DETAILS: '/api/v1/social_media_details/$candidate_id',
                                                   ADD_DOCUMENT: '/api/v1/client_candidates/$applicant_id/add_document',
                                                   LIKE_CANDIDATE: '/api/v1/client_candidates/$candidate_id/like_candidate',
                                                   UPDATE_CANDIDATE: '/api/v1/client_candidates/$candidate_id',
                                                   MARK_CV_DEFAULT: '/api/v1/job_applications/$applicant_id/mark_as_default',
                                                   MARK_CV_DEFAULT_GENERAL_PROFILE: '/api/v1/client_candidates/$candidate_id/mark_as_default',
                                                   DELETE_DOCUMENT:'/api/v1/job_applications/$applicant_id/delete_documents',
                                                   DELETE_DOCUMENT_GENERAL_PROFILE:'/api/v1/client_candidates/$candidate_id/delete_documents',
                                                   UPLOAD_CVS: '/api/v1/client_candidates/upload_cvs',
                                                   UPLOAD_ZIP: '/api/v1/client_candidates/zip_upload',
                                                   BULK_IMPORT: '/api/v1/client_candidates/bulk_import',
                                                   UPLOAD_CSV: '/api/v1/client_candidates/upload_csv',
                                                   TALENT_POOL: '/api/v1/talent_pools',
                                                   EDIT_TALENT_POOL: '/api/v1/talent_pools/$id',
                                                   ADD_CANDIDATE_TO_POOL: '/api/v1/talent_pools/$talent_pool_id/add_candidate_to_pool',
                                                   KANBAN_ADD_CANDIDATE_TO_POOL: '/api/v1/kanban/$job_id/add_candidate_to_pool',
                                                   REMOVE_CANDIDATE_FROM_POOL: '/api/v1/talent_pools/$talent_pool_id/remove_candidate_from_pool'
                                                },
                                  applicant:{
                                                CANDIDATE_INFO:`/api/v1/job_applications/$application_id/view_application`,
                                                LIKE_CANDIDATE:`/api/v1/job_applications/$job_applicant_id/like_candidate`,
                                                ADD_NOTE: `/api/v1/job_applications/$applicant_id/add_note`,
                                                SHARE_CV: `/api/v1/job_applications/$applicant_id/share_cv`,
                                                CANDIDATE_SHARE_CV: `/api/v1/client_candidates/$candidate_id/share_cv`,
                                                CANDIDATE_UPDATE_INFO:'/api/v1/job_applications/$applicant_id/update_application',
                                                SAVE_SCORECARD: '/api/v1/job_applications/$applicant_id/save_scorecard',
                                                GET_EMAILS: `/api/v1/job_applications/$applicant_id/fetch_email`,
                                                GENERAL_CANDIDATE_GET_EMAILS: `/api/v1/client_candidates/$candidate_id/fetch_email`,
                                                SEND_EMAIL: `/api/v1/job_applications/$applicant_id/send_email`,
                                                GENERAL_SEND_EMAIL:`/api/v1/client_candidates/$candidate_id/send_email`,
                                                CANDIDATE_SEND_EMAIL: `/api/v1/talent_pools/send_email`,
                                                VIEW_APPLICATION_PROFILE: `/api/v1/view_application_profile`,
                                                RESTRICTED_LIKE_CANDIDATE:`/api/v1/like_candidate`,
                                                RESTRICTED_ADD_NOTES: `/api/v1/add_note`,
                                                CANDIDATE_ADD_NOTE: `/api/v1/client_candidates/$candidate_id/add_note`,
                                                GENERAL_PROFILE: `/api/v1/client_candidates/$candidate_id/general_view`,
                                                LOAD_MORE_DOCS: `/api/v1/client_candidates/$candidate_id/load_more_docs`,
                                                DOWNLOAD_ATTACHMENTS: '/api/v1/job_applications/$job_application_id/download_attachment',
                                                TIMELINE: '/api/v1/job_applications/$applicant_id/timeline',
                                                RESEND_TEST: '/api/v1/job_applications/$job_application_id/$tech_test_id/resend_tech_test'
                                            },
                                  kanban: {
                                             GET_APPLICATIONS_DATA: `${HOST}/api/v1/kanban/$job_slug/list_candidates`,
                                             GET_FILTERED_APPLICATIONS: '/api/v1/kanban/$job_slug/list_candidates',
                                             MARK_ACTIVE_UNSUCCESSFUL: '/api/v1/kanban/$job_id/active_or_unsuccessful',
                                             ADD_TO_JOB: '/api/v1/kanban/$job_id/add_to_another_jobs',
                                             SEND_TECH_TEST: '/api/v1/kanban/$job_id/send_tech_test',
                                             SEND_VIDEO_QA_INTERVIEW: '/api/v1/kanban/$job_id/send_video_q_a_interview',
                                             IMPORT_CANDIDATES: '/api/v1/kanban/$job_id/import_candidates',
                                             MOVE_CANDIDATES: '/api/v1/kanban/$job_id/move_candidates',
                                             RUN_AUTOMATION: '/api/v1/kanban/$job_id/run_automations',
                                             SEND_QUESTIONS: '/api/v1/kanban/$job_id/send_questions',
                                             UNSUCCESSFUL_REASONS: '/api/v1/kanban/unsuccessful_reasons',
                                             GET_SCORE_CARDS: '/api/v1/job_applications/$job_application_id/scorecards',
                                             SEND_EMAIL: '/api/v1/kanban/$job_id/send_email',
                                             SEND_UNSUCCESSFUL_EMAIL: '/api/v1/kanban/$job_id/send_unsuccessful_email',
                                             UPDATE_TECH_TEST_SCORE: '/api/v1/job_application_tech_test_details/$tech_test_id',
                                             ADD_MEMBER_KANBAN: '/api/v1/jobs/$job_id/job_stages/$job_stage_id',
                                             ADD_NEW_STAGE: '/api/v1/kanban/$job_id/add_stage',
                                             NEW_STAGE_INFO: '/api/v1/kanban/$job_id/list_types_positions',
                                             COMPARE_SCORECARDS: '/api/v1/kanban/$job_id/compare_scorecards',
                                             HIRED_SYNC_DATA: '/api/v1/kanban/$job_id/hired_sync_data'
                                          },
                                  cronofy: {
                                             GET_CRONOFY_HASH: `${HOST}/api/v1/cronofy_hash`,
                                             GET_MORE_DAYS_SLOTS: '/api/v1/cronofy_hash',
                                             BOOK_INTERVIEW: '/api/v1/schedule_meeting',
                                             REQUEST_FOR_SLOTS: '/api/v1/request_more_slots',
                                             CANCEL_INTERVIEW: '/api/v1/cancel_meeting',
                                             CANCEL_INTERVIEW_BY_CLIENT: '/api/v1/job_application_meetings/$meeting_id/cancel_interview',
                                             RESCHEDULE_REQUEST: '/api/v1/reschedule_meeting',
                                             RESEND_INVITE: '/api/v1/job_application_meetings/$meeting_id/send_invite',
                                             GET_NEW_MEETING_DETAILS: '/api/v1/job_application_meetings/new',
                                             GET_MEETING_DETAILS: '/api/v1/job_application_meetings/$meeting_id',
                                             ADD_INTERVIEW: '/api/v1/job_application_meetings',
                                             SETUP_INTERVIEW: '/api/v1/job_application_meetings/manual_kanban_meeting',
                                             VIEW_MEETING_REQUEST: '/api/v1/job_application_meetings/$meeting_id/view_request',
                                             VIEW_MEETING_DETAILS: '/api/v1/job_application_meetings/$meeting_id/view_details',
                                             RESCHEDULE_INTERVIEW: '/api/v1/job_application_meetings/$meeting_id/send_more_slots',
                                             AVAILABLE_SLOTS: '/api/v1/job_application_meetings/$meeting_id/available_slots',
                                             ACCEPT_SLOT: '/api/v1/job_application_meetings/$meeting_id/accept_slot',
                                             UPDATE_CONTACT_NO: '/api/v1/update_contact_no'
                                          },
                                  offer: {
                                             CREATE: '/api/v1/offers',
                                             NEW: '/api/v1/offers/new',
                                             EDIT: '/api/v1/offers/$offer_id/offer_detail',
                                             UPDATE: '/api/v1/offers/$offer_id',
                                             VIEW_OFFER: `${HOST}/api/v1/view_offer`,
                                             ACCEPT_OFFER: `/api/v1/accept_offer`,
                                             DECLINE_OFFER: '/api/v1/decline_offer',
                                             SIGN_CONTRACT: `${HOST}/api/v1/view_contract`
                                         },
                                  welcome: {
                                              GET_USER_INFO: `${HOST}/api/v1/users/email`,
                                              ACCEPT_INVITE_SET_PASSWORD: '/api/v1/users/invitation',
                                              invite_admin: `${HOST}/api/v1/roles`,
                                              GET_ACCESS: `/api/v1/authorize_user`
                                            },
                                  invite_admin: '/api/v1/clients/$client_id/add_users',
                                  career:{
                                             // PAGE_DATA: `${process.env.NEXT_PUBLIC_POPLIFY_URL}/api/v1/careers`
                                             PAGE_DATA: `/api/v1/career_page/customise`,
                                             CUSTOMIZE_CAREER: `${HOST}/api/v1/career_page/customise`,
                                             CAREER_PAGE_PREVIEW: `${HOST}/api/v1/career_page/customise`,
                                             CAREER_PAGE_UPDATE: '/api/v1/career_page/update',
                                             PUBLISH_CAREER_PAGE: '/api/v1/career_page/publish',
                                             RESET_CAREER_PAGE: '/api/v1/career_page/reset'
                                          },
                                  my_preferences: {
                                                      ADD_MY_PREFERENCES_URL: `/api/v1/preferences`,
                                                      GET_MY_PREFERENCES_URL: `/api/v1/my_preferences`,
                                                      UPDATE_TIME_ZONE: `/api/v1/show_preferences`
                                                  },

                                  jobs_api:{
                                                GET_JOB_API         :   '/api/v1/clients/$client_slug/api_key',
                                                REGENERATE_JOB_API  :   '/api/v1/clients/$client_slug/api_key'
                                           },
                                  my_notifications:{
                                                      GET_NOTIFICATION: `/api/v1/notifications/my_notifications`,
                                                      SET_NOTIFICATION: `/api/v1/notifications/$key`
                                                   },
                                  jobs: {
                                     GET_JOB_DATA: `/api/v1/jobs/new`,
                                     GET_JOB: `/api/v1/jobs/$job_id`,
                                     GET_JOB_TITLES: '/api/v1/job_titles',
                                     GET_DEPARTMENTS: '/api/v1/jobs/department_list',
                                     GET_JOB_BY_TITLE: '/api/v1/job_titles/$job_title_id/search_job',
                                     CREATE_JOB: '/api/v1/jobs',
                                     CLOSE_JOB: '/api/v1/jobs/$job_id/close',
                                     IMPORT_SCORECARD: '/api/v1/jobs/$job_id/import_scorecard_template',
                                     CHECK_EDIT: '/api/v1/jobs/$job_id/check_edit',
                                     UPDATE_JOB: '/api/v1/jobs/$job_id',
                                     DELETE_JOB: '/api/v1/jobs/$job_id',
                                     DUPLICATE_JOB: '/api/v1/jobs/$job_id/duplicate',
                                     PREVIEW_JOB: `${HOST}/api/v1/jobs/$job_id/preview`,
                                     PUBLISH_JOB: '/api/v1/jobs/$job_id/publish',
                                     VIEW_JOB: `${HOST}/api/v1/jobs/$slug/view_job`,
                                     VIEW_SCREENING_QUESTIONS: `${HOST}/api/v1/jobs/$slug/view_screening_questions`,
                                     GET_JOB_OPTIONS_DATA: `/api/v1/jobs/$job_id/job_options_data`,
                                     ADD_JOB_OPTIONS_DATA: `/api/v1/jobs/$job_id/add_job_options`,
                                     GET_STAGE_INTERVIEW_TYPE_DATA: `/api/v1/jobs/$job_id/stages_interview_types`,
                                     GET_CLIENT_USERS: '/api/v1/jobs/list_users',
                                     GET_USERS_LIST: '/api/v1/job_application_meetings/list_users',
                                     ADD_JOB_STAGES: '/api/v1/jobs/$job_id/add_stages',
                                     UPDATE_THRESHOLD: '/api/v1/jobs/$job_id/job_stages/$job_stage_id/update_threshold',
                                     UPDATE_AUTOMATIONS: '/api/v1/jobs/$job_id/update_automations',
                                     JOB_STAGES_LIST: `/api/v1/jobs/$job_id/job_stages`,
                                     JOB_STAGE_DATA:  '/api/v1/jobs/$job_id/job_stages/$job_stage_id/edit',
                                     MANUAL_JOB_STAGE_DATA:  '/api/v1/job_application_meetings/manual_kanban_stage_detail',
                                     MANUAL_NOT_SENT_DATA:  '/api/v1/job_application_meetings/manual_kanban_column_detail',
                                     ADD_AUTOMATIONS:  '/api/v1/jobs/$job_id/job_stages/$job_stage_id/meeting_details',
                                     VIDEO_PLATFORMS: `/api/v1/job_meeting_details/list_platforms`,
                                     // ASYNC_VIDEO_PLATFORMS: `${HOST}/api/v1/job_meeting_details/list_platforms`,
                                     GET_COMPETENCIES: '/api/v1/jobs/get_competencies',
                                     GET_COMPETENCIES_LIST: '/api/v1/jobs/list_competencies',
                                     ADD_COMPETENCIES: '/api/v1/jobs/$job_id/add_competencies',
                                     GET_JOB_BOARDS: `/api/v1/jobs/$job_id/list_integrations`,
                                     ADD_JOB_BOARDS: '/api/v1/jobs/$job_id/add_job_sharing_boards',
                                     GET_TECH_TESTS: '/api/v1/test_libraries',
                                     ADD_TECH_TESTS: '/api/v1/jobs/$job_id/job_stages/$job_stage_id/meeting_details',
                                     APPLY_JOB: '/api/v1/jobs/$job_slug/apply',
                                     SUBMIT_ANSWERS: '/api/v1/jobs/$job_slug/submit_answers',
                                     PARSE_CV: '/api/v1/parse_cv_via_daxtra',
                                     CONFIRM_APPLICATION: '/api/v1/jobs/verify_email',
                                     VIEW_APPLICATION: `${HOST}/api/v1/view_application/$application_id`,
                                     FETCH_CANDIDATE: `${HOST}/api/v1/fetch_cv_library_candidate/$cv_token`,
                                     FETCH_SCORECARD: `${HOST}/api/v1/jobs/$job_slug/download_scorecard`,
                                     FETCH_CANDIDATE_CV: `${HOST}/api/v1/jobs/$job_slug/view_candidate_cv`,
                                     REVIEW_AUTOMATION_EMAIL: '/api/v1/jobs/$job_id/review_automation_email',
                                     SAVE_EMAIL_TEMPLATE: '/api/v1/jobs/$job_id/save_template',
                                     GET_SHARE_USERS: '/api/v1/jobs/share_users_list',
                                     GET_AGENCY_USERS: '/api/v1/jobs/agency_users_list',
                                     GET_JOB_APPROVAL_DATA: '/api/v1/job_approvals/$approval_id/job_summary',
                                     APPROVE_JOB_APPROVAL_DATA: '/api/v1/job_approvals/$approval_id/approve_job',
                                     REJECT_JOB_APPROVAL_DATA: '/api/v1/job_approvals/$approval_id/reject_job',
                                     JOB_APPROVAL_LISTING: '/api/v1/job_approvals',
                                     REJECT_MERGE_CANDIDATE: '/api/v1/client_candidates/$candidate_id/reject_merge',
                                     GET_MERGE_CANDIDATE_DATA: '/api/v1/client_candidates/$candidate_id/duplicate_candidate',
                                     SEND_MERGE_CANDIDATE: '/api/v1/client_candidates/$candidate_id/merge',
                                     RESTRICTED_JOB_SUMMARY: '/api/v1/get_job_approval_summary',
                                     RESTRICTED_REJECTED_JOB: '/api/v1/reject_job',
                                     RESTRICTED_APPROVE_JOB:'/api/v1/approve_job',
                                     GET_IMPORT_JOB_TEMPLATE_DATA : '/api/v1/job_templates/index',
                                     IMPORT_JOB_TEMPLATE : '/api/v1/job_templates/import_job',
                                     UPDATE_JOB_LIVE_MODAL_SHOW_STATUS_FALSE:'/api/v1/jobs/set_job_live_modal_shown_status_false',
                                     ACCEPT_MERGE_APPLICATION: '/api/v1/job_applications/$job_application_id/merge',
                                     REJECT_MERGE_APPLICATION: '/api/v1/client_candidates/$job_application_id/reject_merge',
                                     GENERATE_DESCRIPTION: '/api/v1/job_templates/generate_description',
                                     CHECK_AGENCY_USER_EXIST: '/api/v1/jobs/agency_user_exist',
                                     ADD_AGENCY_USER_RESPONSE : '/api/v1/jobs/add_agency_user_response',
                                     GET_JOB_BOARD_EXTRA_DATA : '/api/v1/jobs/get_job_board_extra_fields',
                                     UPDATE_ADVERT: 'api/v1/jobs/$advert-id/adverts',
                                  },
                                  contracts: {
                                                GET_CONTRACT_DATA: '/api/v1/job_applications/$job_application_id/get_contract_data',
                                                SEND: '/api/v1/job_applications/$job_application_id/send_contract',
                                                PREVIEW: '/api/v1/contracts/$contract_id/preview',
                                                DOWNLOAD: '/api/v1/contracts/$contract_id/download',
                                                CONTRACT_LIST: '/api/v1/contracts'
                                             },
                                 gdpr: {
                                   PRE_DELETION_CONFIRM: `${HOST}/api/v1/show_gdpr_retention_confirmation`,
                                 },
                                 activities: {
                                                CLIENT_INTEGRATIONS_URL: `/api/v1/client_integrations`,
                                                INTEGRATION_ACCESSIBILITY_URL: '/api/v1/client_integrations/$integration_id/update_accessibility',
                                                MY_INTEGRATIONS_URL: `${HOST}/api/v1/client_integrations/my_integrations`,
                                                MY_INTEGRATIONS_DATA_URL: `/api/v1/client_integrations/my_integrations`,
                                                SEND_INTEGRATION_CODE: '/api/v1/client_integrations/$slug/authorize_user',
                                                DISCONNECT_INTEGRATION: '/api/v1/client_integrations/$integration_id/disconnect',
                                                MY_INTEGRATIONS_CONNECT: '/api/v1/user_integrations/$integration_id/authorize_user',
                                                MY_INTEGRATIONS_DISCONNECT: '/api/v1/user_integrations/$integration_id/disconnect',

         DASHBOARD: '/api/v1/onboarding/index',
         UPDATE_ONBOARDING_STEP: '/api/v1/onboarding/update_onboarding_step',
         DISMISS_ONBOARDING: '/api/v1/onboarding/dismiss',
         GET_USER_DETAILS: '/api/v1/my_account',
         UPDATE_USER_DETAILS: '/api/v1/client_users/$client_slug',

         GET_MY_TEAM: '/api/v1/onboarding/my_teams',
         ADD_TEAM_MEMBERS: '/api/v1/client_users/add_members',
         SHOW_ACTIVITIES_DATA: '/api/v1/activities',
         DISMISS_ALERT_COMM: '/api/v1/activities/delete_notification',

         CUSTOM_INTEGRATIONS: '/api/v1/custom_integrations',
         UPDATE_CUSTOM_INTEGRATIONS: '/api/v1/custom_integrations/$integration_id',
         OFFER_REJECTED_REASONS: '/api/v1/offers/$offer_id/rejected_reasons',
         JOB_REJECTED_REASONS: '/api/v1/offers/$offer_id/rejected_reasons'
      },
      company: {
         USER_LIST: '/api/v1/client_users',
         UPDATE_USER_STATUS: '/api/v1/client_users/$client_id/update_status',
         RESENT_INVITE: '/api/v1/client_users/$client_id/resend_invite',
         ADD_CLIENTS: '/api/v1/client_users/add_members',
         CLIENT_DETAILS: '/api/v1/client_users/$client_id',
         AGENCY_USER_DETAILS: '/api/v1/agencies/$agency_id/edit_agency_user/$member_id',
         GET_MY_TEAM: `${HOST}/api/v1/onboarding/my_teams`,
         COMPANY_PROFILE: `/api/v1/profiles/company_profile`,
         GDPR_RETENTION_OPTIONS: '/api/v1/clients/$slug/gdpr_settings',
         GDPR_POLICY: `/api/v1/client_gdpr_policies/$id`,
         EMAIL_BRANDING: '/api/v1/clients/$slug/email_branding',
         COMPANY_PROFILE_UPDATE: `/api/v1/profiles/update`,
         AGENCIES_LIST: '/api/v1/agencies',
         ADVERT_DATA: '/api/v1/clients/$slug/client_job_advert_settings',
         UPDATE_ADVERT_DATA: '/api/v1/job_advert_settings/$advert-id',
         TOGGLE_AGENCY_STATUS: '/api/v1/agencies/$agency_id/toggle_status',
         ADD_NEW_AGENCY: '/api/v1/agencies',
         UPLOAD_TERMS: '/api/v1/agencies/$agency_id/upload_terms',
         GET_AGENCY_DATA: '/api/v1/agencies/$agency_id/show',
         UPDATE_AGENCY_DATA: '/api/v1/agencies/$agency_id',
         GET_AGENCY_DETAILS: '/api/v1/agencies/$agency_id/details_tab',
         GET_AGENCY_USERS: '/api/v1/agencies/$agency_id/users_tab',
         GET_AGENCY_JOBS: '/api/v1/agencies/$agency_id/jobs_tab',
         GET_AGENCY_JOB_USERS: '/api/v1/agencies/$agency_id/share_unshare_job/$job_slug',
         GET_AGENCY_USER_ROLES: `${HOST}/api/v1/agency/base/list_roles`,
         AGENCY_USER_RESEND_INVITE: '/api/v1/agencies/$agency_id/resend_invite',
         AGENCY_USER_STATUS_TOGGLE: '/api/v1/agencies/$agency_id/toggle_agency_user_status',
         DOWNLOAD_CSV: '/api/v1/agencies/$agency_id/download_csv',
         INVITE_AGENCY_USER: '/api/v1/agencies/$agency_id/invite_agency_user'
      },
      privacy_policy: {
         SHOW: '/api/v1/privacy_policy/show',
         UPDATE: '/api/v1/privacy_policy',
         GENERATE: '/api/v1/generate_policy'
      },
      unsuccessful_reasons: {
         REASON_LIST: '/api/v1/client_user_unsuccessful_reasons',
         CREATE_REASON: '/api/v1/client_user_unsuccessful_reasons',
         RUD_REASON: '/api/v1/client_user_unsuccessful_reasons/$reason_id'

      },
      manage_assessment: {
         ASSESSMENT_LIST: '/api/v1/assessments',
         CREATE_ASSESSMENT: '/api/v1/assessments',
         SHOW_ASSESSMENT: '/api/v1/assessments/$assessment_id',
         UPDATE_ASSESSMENT: '/api/v1/assessments/$assessment_id',
         DELETE_ASSESSMENT: '/api/v1/assessments/$assessment_id'
      },
      contract_templates: {
         TEMPLATE_LIST: '/api/v1/signature_templates',
         CREATE_TEMPLATE: '/api/v1/signature_templates',
         UPDATE_TEMPLATE: '/api/v1/signature_templates/$template_id/publish',
         GET_EDIT_URL: '/api/v1/signature_templates/$template_id/get_edit_url',
         DELETE_TEMPLATE: '/api/v1/signature_templates/$template_id'
      },
      scorecard_templates: {
         TEMPLATE_LIST: '/api/v1/scorecard_templates',
         CREATE_TEMPLATE: '/api/v1/scorecard_templates',
         UPDATE_TEMPLATE: '/api/v1/scorecard_templates/$template_id',
         GET_TEMPLATE: '/api/v1/scorecard_templates/$template_id',
         DELETE_TEMPLATE: '/api/v1/scorecard_templates/$template_id'
      },
      calendar_invites: {
         CALENDAR_INVITE_LIST: '/api/v1/user_calendar_invite_templates',
         UPDATE_CALENDAR_INVITE: '/api/v1/user_calendar_invite_templates/$calendar_invite_id',
         GET_CALENDAR_INVITE: '/api/v1/user_calendar_invite_templates/$calendar_invite_id',
         RESET_CALENDAR_INVITE: '/api/v1/user_calendar_invite_templates/$calendar_invite_id/reset',
      },
      career_site: {
         RESET_CAREER: '/api/v1/career_page/reset'
      },
      reports: {
         SOURCE: '/api/v1/reports/source_report',
         ADVANCE_SOURCE: '/api/v1/reports/individual_source_report',
         IN_PROCESS: '/api/v1/reports/in_process_graph_data',
         AVG_TIME_HIRE: '/api/v1/reports/avg_time_to_hire',
         INTERVIEW_BY_STAGE: '/api/v1/reports/interviews_by_stage',
         CURRENT_PIPELINE: '/api/v1/reports/current_pipeline',
         PIPELINE_SPEED: '/api/v1/reports/pipeline_speed',
         PIPELINE_CONVERSION: '/api/v1/reports/pipeline_conversion',
         LIVE_JOB_BY_AGE: '/api/v1/reports/live_jobs_by_age',
         LIVE_JOB_BY_TIME: '/api/v1/reports/live_jobs_by_time',
         PIPELINE_HEALTH: '/api/v1/reports/get_pipeline_health',
         ACTIVATE_JOB_LIST: '/api/v1/reports/jobs_list',
         DOWNLOAD_CSV_CURRENT_PIPELINE:'/api/v1/reports/current_pipeline_export',
         GDPR_REPORTS_DATA:'/api/v1/reports/gdpr_report_data'
      },
      communication: {
         COMMUNICATION_DATA:'/api/v1/user_comm_details',
         MARK_READ:'/api/v1/user_comm_details/mark_as_read',
         DISMISS:'/api/v1/user_comm_details/dismiss',
         GET_CANDIDATE_OPTIONS:'',
         GET_JOB_OPTIONS:'',
         GET_EMIAL_DATA: '/api/v1/user_comm_details/$comms_id',
         MARK_AS_IMPORTANT:'/api/v1/user_comm_details/mark_as_important',
         THREAD_DELETE:'/api/v1/user_comm_details/thread_delete'
      }

   },
   open: {
      // GET_CAREER_PAGE_DATA: `${process.env.NEXT_PUBLIC_POPLIFY_URL}/api/v1/careers`,
      GET_CAREER_PAGE_DATA: `${HOST}/api/v1/careers`,
      SEND_CAREER_PAGE_SEARCH_DATA: `/api/v1/careers`,
      UPLOAD_SIGNATURE_IMAGE: `/api/v1/upload_signature_image`,
      SEND_IFRAME_SEARCH_DATA: `/api/v1/job_openings`,
      GET_IFRAME_JOBS_DATA: `${HOST}/api/v1/job_openings`
   },
   email_templates: {
      GET_VARIABLES: '/api/v1/templates/list_client_users',
      SYSTEM_TEMPLATE_LIST: '/api/v1/templates?type=system',
      CUSTOM_TEMPLATE_LIST: '/api/v1/templates?type=custom',
      CREATE_CUSTOM_EMAIL: '/api/v1/templates',
      GET_EMAIL_TEMPLATE: '/api/v1/templates/$template_id',
      DELETE_CUSTOM_TEMPLATE: '/api/v1/templates/bulk_delete',
      UPDATE_EMAIL_TEMPLATE: '/api/v1/templates/$template_id',
      RESET_EMAIL_TEMPLATE: '/api/v1/templates/$template_id/reset',
      CLIENT_PURPOSE_LIST: '/api/v1/templates/new',
      CLIENT_MEMBER_LIST: '/api/v1/templates/list_client_users',
      GDPR_EMAIL_TEMPLATES: '/api/v1/gdpr_email_templates/$id',
      GDPR_EMAIL_TEMPLATES_RESET: '/api/v1/gdpr_email_templates/$id/reset'
   },
   agency: {
      dashboard: '/api/v1/dashboard',
      dismiss: '/api/v1/dashboard/dismiss',
      job_listing: '/api/v1/dashboard/list_jobs',
      job_details: '/api/v1/dashboard/view_agency_user_job',
      create_candidate: '/api/v1/candidates/submit_candidate',
      AGENCY_USER_DETAILS: '/api/v1/agency_users/$candidate_slug',
      CANDIDATE_DATA: '/api/v1/candidates/$candidate_id',
      AGENCY_PROFILE_DETAILS: '/api/v1/agency_profile/show_profile',
      AGENCY_CLIENT_DETAILS: '/api/v1/agency_profile/show_client',
      AGENCY_UPDATE_PROFILE: '/api/v1/agency_profile/update_agency_client',
      USER_LISTING: '/api/v1/agency_users/list_users',
      ACTIVATE_DEACTIVATE: '/api/v1/agency_users/toggle_status/$user_slug',
      RESEND_INVITE: '/api/v1/agency_users/resend_invite/$user_slug',
      USER: '/api/v1/agency_users',
      SWITCH_ROLE: '/api/v1/switch_role',
      SWITCH_LIST: '/api/v1/clients_agencies',
      MERGE_CANDIDATE_LISTING: '/api/v1/client_candidates/$candidate_id/merge_list'
   },

   VIDEO_QA_INTERVIEW:{
                           SHOW: '/api/v1/jobs/$job_id/job_stages/$job_stage_id/show_video_question_details',
                           CREATE:'/api/v1/jobs/$job_id/job_stages/$job_stage_id/create_video_question_details',
                           UPDATE:'/api/v1/jobs/$job_id/job_stages/$job_stage_id/update_video_question_details',
                           CANDIDATE_DATA:'/api/v1/get_questions_for_candidate',
                           SET_CANDIDATE_INTRODUCTION: '/api/v1/update_candidate_introduction',
                           UPDATE_VIDEO_QA: '/api/v1/update_video_qa_introduction'
                      },

   scorecards:{
               COMPETENCY_SUBCOMPETENCY_DATA:'/api/v1/jobs/list_competencies',
             }

}

export const REDIRECT = {
   admins: {
      otp: '/admins/otp',
      dashboard: '/admins/dashboard',
      login: '/admins/login',
      reset_password: '/admins/reset-password',
      request_sent: '/admins/request-sent',
      dashboard: {
         activities: '/admins/activities/activity',
         clients: {
            client: '/admins/clients/client?client_type=active',
            company: '/admins/clients/new',
            edit: '/admins/clients/$client_id/edit',
            users: '/admins/clients/$client_id/add-users',
            integration: '/admins/clients/$client_id/integrations',
         },
         user: {
            index: '/admins/users',
            add_member: '/admins/users/add-members',
            view_members: '/admins/users/$admin_id/view-profile'
         },
         my_account: '/admins/my-account'

      }
   },

   client: {
      otp: '/clients/otp',
      login: '/clients/welcome',
      success: '/clients/success',
      invite_admin: '/clients/invite-admin',
      reset_password: '/clients/reset-password',
      request_sent: '/clients/request-sent',
      activities: '/clients/activities',
      quick_setup: '/clients/activities/quick-setup?step=',
      quick_setup_page: '/clients/activities/quick-setup',
      client_integrations: '/clients/company-integrations',
      company_integrations: '/clients/company-integrations?type=default',
      my_integrations: '/clients/my-integration',
      jobs_api: '/clients/jobs-api',
      my_preferences: '/clients/my-preferences',
      integration_connected: '/clients/activities/integration-connected',
      candidates: {
         add_candidate: '/clients/candidates/add-candidate',
         candidate_listing: '/clients/candidates'
      },
      offers: {
         approval_page: '/clients/jobs/$job_id/offers/$offer_approver_id/approval-request-offer'
       },

      jobs: {
         new: '/clients/jobs/new',
         edit: '/clients/jobs/$job_id/edit',
         job_options: '/clients/jobs/$job_id/job-options',
         interview_stages: '/clients/jobs/$job_id/interview-stages',
         interview_details: '/clients/jobs/$job_id/interview-details',
         scorecards: '/clients/jobs/$job_id/scorecards',
         job_sharing: '/clients/jobs/$job_id/job-sharing',
         preview_job: '/clients/jobs/$job_id/job-preview',
         view_job: '/$client_slug/$slug/view-job',
         view_career_page: '/careers',
         view_job_openings: '/job-openings',
         index: '/clients/jobs',
         application_sent: '/jobs/application-sent',
         candidate_profile_job: '/clients/jobs/$job_id/applications/$applicant_id/candidate-profile-job',
         candidate_profile_view: '/clients/candidates/$candidate_id/view-profile',
         merge_duplicate_users: '/clients/jobs/candidate/$candidate_id/merge-record/duplicate-candidate/$duplicate_id',
         merge_listing: '/clients/jobs/candidate/$candidate_id/merge-listing',
         approvals_listing: '/clients/jobs/approval-listing',
         offer_approval_request: '/clients/jobs/$job_id/offers/$offer_approver_id/approval-request-offer',
         job_summary:'/clients/jobs/$job_slug/approval/$approval_id/job-summary',
         send_contract: '/clients/jobs/$job_id/applications/$job_application_id/send-contract',
         contract_listing: '/clients/jobs/contract-listing',
         send_template_contract: '/clients/jobs/$job_id/applications/$job_application_id/send-template-contract',
         compare_candidates: '/clients/jobs/compare-candidates',
         new_edit_scorecard: '/clients/jobs/new-edit-scorecard'
      },
      company: {
         add_team: '/clients/company/add-team',
         add_members: '/clients/company/add-members',
         view_members: '/clients/company/$member_id/view-profile',
         company_profile: '/clients/company/company-profile',
         agencies: '/clients/company/agencies',
         add_new_agency: '/clients/company/add-agency',
         edit_agency: '/clients/company/$agency_id/agency-form',
         agency_users: '/clients/company/$agency_id/agency-users',
         invite_agency_users: '/clients/company/$agency_id/invite-agency-users',
         agency_user_profile: '/clients/company/$agency_id/$member_id/agency-user-profile',
      },

      kanban_board: '/clients/jobs/$job_id/kanban',
      settings: {
         personal: {
            my_account: '/clients/my-account'
         },
         data_privacy: {
            privacy_policy: '/clients/data-privacy/privacy-policy',
            gdpr:'/clients/data-privacy/gdpr',
         }
      },
      users: {
         view_member: '/clients/users/$member_id/view-profile'
      },
      recruitment: {
         email_templates: '/clients/recruitments/email-templates?email_type=system',
         unsuccessful_reasons: '/clients/recruitments/unsuccessful-reasons',
         manage_assessment: '/clients/recruitments/manage-assessment',
         calendar_invites: '/clients/recruitments/calendar-invites',
         contract_templates: '/clients/recruitments/contract-templates',
         create_template: '/clients/recruitments/create-template',
         scorecard_templates: '/clients/recruitments/scorecard-templates',
      },
      branding: {
         career_page_settings: '/clients/career/career-setting',
         edit_career_page: '/clients/career/customize-career-page',
         career_preview: '/clients/career/customize-preview',
         job_adverts: '/clients/job-adverts',
         email_branding: '/clients/branding/email-branding' // new route
      },
      reports: {
         source: '/clients/reports/candidate-overview/source',
         advance_source: '/clients/reports/candidate-overview/advance-source',
         in_process: '/clients/reports/candidate-overview/in-process',
         time_to_hire: '/clients/reports/candidate-overview/time-to-hire?date_choice=all_time',
         gdpr: '/clients/reports/candidate-overview/gdpr?date_choice=this_week',

         pipeline_health: '/clients/reports/candidate-overview/$slug/pipeline-health',

         // Name of these things will be changes
         live_jobs_by_age: '/clients/reports/job-overview/live-jobs-by-age',
         total_jobs_live_overtime: '/clients/reports/job-overview/total-jobs-live-overtime?date_choice=all_time',

         // avg_candidate_time_in_stage:'/clients/reports/pipeline-health/avg-candidate-time-in-stage',
         // by_stage: '/clients/reports/pipeline-health/by-stage',

         interview_by_stages: '/clients/reports/interviews/current-pipeline',
         pipeline_speed: '/clients/reports/interviews/pipeline-speed?date_choice=all_time',
         pipeline_conversion: '/clients/reports/interviews/pipeline-conversion?date_choice=all_time',

      },
      communication: {
         index: '/clients/communication',
         emails: '/clients/communication/$comm_detail_id/emails',
         inbox: '/clients/communication?email_type=inbox',
         sent: '/clients/communication?email_type=sent'
      }
   },
   agency: {
      login: '/agency/welcome',
      reset_password: '/agency/reset-password',
      dashboard: {
         activities: '/agency/activities',
         jobs: '/agency/jobs?status=Active',
         users: '/agency/users',
         profile: '/agency/profile',
         job_detail: '/agency/jobs/$job_slug/details',
         my_account: '/agency/my-account',
         add_candidate: '/agency/jobs/$job_slug/candidate/add',
         edit_candidate: '/agency/jobs/$job_slug/candidate/$candidate_id/edit',
         view_profile: '/agency/users/$slug/profile',
         add_user: '/agency/users/add',
         edit_user: '/agency/users/$slug/edit-user',
      },
      welcome: '/agency/welcome',
      otp: '/agency/otp',
   },
   heartpace_url: CURRENT_ENV == "production" ? "https://$client_doamin.heartpace.com" : "https://$client_doamin.heartpace.dev"
};
